function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -20 601.85 143",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 98.5,8.5 C 98.8307,30.3398 98.4973,52.0064 97.5,73.5C 94.4475,72.2231 91.6141,70.5564 89,68.5C 88.6667,54.5 88.3333,40.5 88,26.5C 68.6295,38.0329 49.1295,49.3663 29.5,60.5C 28.2023,56.2846 28.2023,52.1179 29.5,48C 52.5274,34.8215 75.5274,21.6548 98.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#858586",
    d: "M 98.5,8.5 C 99.8284,30.337 99.8284,52.337 98.5,74.5C 97.8933,74.3764 97.56,74.0431 97.5,73.5C 98.4973,52.0064 98.8307,30.3398 98.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 100.5,8.5 C 103.758,9.90759 106.924,11.5743 110,13.5C 110.667,40.5 110.667,67.5 110,94.5C 91.255,84.2123 72.755,73.5457 54.5,62.5C 57.3771,60.139 60.5437,58.139 64,56.5C 76.0233,63.5917 88.19,70.2584 100.5,76.5C 100.5,53.8333 100.5,31.1667 100.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 145.5,27.5 C 148.167,27.5 150.833,27.5 153.5,27.5C 153.5,43.8333 153.5,60.1667 153.5,76.5C 166.167,76.5 178.833,76.5 191.5,76.5C 191.5,79.1667 191.5,81.8333 191.5,84.5C 176.255,84.8242 161.089,84.4908 146,83.5C 145.5,64.8363 145.333,46.1696 145.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 198.5,27.5 C 200.833,27.5 203.167,27.5 205.5,27.5C 205.5,46.5 205.5,65.5 205.5,84.5C 202.881,84.7683 200.381,84.435 198,83.5C 197.181,64.7599 197.347,46.0932 198.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4f5",
    d: "M 273.5,83.5 C 273.667,69.1628 273.5,54.8295 273,40.5C 272.283,41.0442 271.783,41.7109 271.5,42.5C 265.011,52.8052 258.511,63.1386 252,73.5C 249.667,74.8333 247.333,74.8333 245,73.5C 238.489,63.1386 231.989,52.8052 225.5,42.5C 225.217,41.7109 224.717,41.0442 224,40.5C 223.5,54.8295 223.333,69.1628 223.5,83.5C 221.105,84.8143 218.605,84.8143 216,83.5C 215.333,65.1667 215.333,46.8333 216,28.5C 219.333,27.1667 222.667,27.1667 226,28.5C 233.25,40.6682 240.75,52.6682 248.5,64.5C 256.167,52.5 263.833,40.5 271.5,28.5C 274.709,27.2126 277.875,27.2126 281,28.5C 281.667,46.8333 281.667,65.1667 281,83.5C 278.395,84.8143 275.895,84.8143 273.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 291.5,27.5 C 294.167,27.5 296.833,27.5 299.5,27.5C 299.667,46.1696 299.5,64.8363 299,83.5C 296.667,84.8333 294.333,84.8333 292,83.5C 291.5,64.8363 291.333,46.1696 291.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 306.5,27.5 C 323.167,27.5 339.833,27.5 356.5,27.5C 356.756,29.7925 356.423,31.9592 355.5,34C 348.842,34.4996 342.175,34.6663 335.5,34.5C 335.667,50.8367 335.5,67.1701 335,83.5C 332.619,84.435 330.119,84.7683 327.5,84.5C 327.5,67.8333 327.5,51.1667 327.5,34.5C 320.492,34.6663 313.492,34.4996 306.5,34C 305.232,31.8368 305.232,29.6702 306.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 362.5,27.5 C 365.167,27.5 367.833,27.5 370.5,27.5C 370.5,43.8333 370.5,60.1667 370.5,76.5C 383.167,76.5 395.833,76.5 408.5,76.5C 408.768,79.1194 408.435,81.6194 407.5,84C 392.592,84.8233 377.759,84.6567 363,83.5C 362.5,64.8363 362.333,46.1696 362.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f6f6",
    d: "M 415.5,27.5 C 431.5,27.5 447.5,27.5 463.5,27.5C 463.5,29.8333 463.5,32.1667 463.5,34.5C 450.167,34.5 436.833,34.5 423.5,34.5C 423.5,40.1667 423.5,45.8333 423.5,51.5C 432.5,51.5 441.5,51.5 450.5,51.5C 450.5,53.8333 450.5,56.1667 450.5,58.5C 441.5,58.5 432.5,58.5 423.5,58.5C 423.5,64.5 423.5,70.5 423.5,76.5C 436.504,76.3334 449.504,76.5001 462.5,77C 463.833,79.3333 463.833,81.6667 462.5,84C 446.592,84.824 430.759,84.6573 415,83.5C 414.181,64.7599 414.347,46.0932 415.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 478.5,27.5 C 488.839,27.3335 499.172,27.5002 509.5,28C 517.268,29.8222 521.268,34.8222 521.5,43C 521.415,44.1074 521.081,45.1074 520.5,46C 518.5,46.6667 516.5,46.6667 514.5,46C 513.782,42.1697 512.115,38.8363 509.5,36C 499.508,34.0309 489.508,34.0309 479.5,36C 476.572,39.2572 475.738,43.0906 477,47.5C 477.903,48.7014 479.069,49.5348 480.5,50C 490.111,51.4798 499.777,52.4798 509.5,53C 518.122,54.2885 522.455,59.2885 522.5,68C 521.859,77.9742 516.526,83.3075 506.5,84C 497.114,84.8527 487.781,84.5194 478.5,83C 470.294,79.719 466.96,73.719 468.5,65C 470.5,64.3333 472.5,64.3333 474.5,65C 475.714,67.3506 476.548,69.8506 477,72.5C 478.319,74.4875 480.152,75.6541 482.5,76C 491.167,76.6667 499.833,76.6667 508.5,76C 512.666,75.015 514.666,72.3484 514.5,68C 514.592,65.1861 513.592,62.8527 511.5,61C 500.531,59.4307 489.531,58.0973 478.5,57C 471.292,55.1226 467.959,50.456 468.5,43C 468.474,35.5282 471.807,30.3615 478.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 541.5,27.5 C 551.172,27.3335 560.839,27.5002 570.5,28C 580.048,30.4333 583.715,36.4333 581.5,46C 579.5,46.6667 577.5,46.6667 575.5,46C 575.394,39.8996 572.394,36.2329 566.5,35C 558.103,34.1301 549.77,34.4635 541.5,36C 538.141,37.1351 536.808,39.4684 537.5,43C 536.808,46.5316 538.141,48.8649 541.5,50C 551.12,51.3851 560.786,52.3851 570.5,53C 581.063,55.2767 585.23,61.7767 583,72.5C 580.74,80.0766 575.573,83.9099 567.5,84C 557.025,85.0959 546.692,84.4292 536.5,82C 530.744,77.6393 528.41,71.806 529.5,64.5C 531.857,64.3367 534.19,64.5034 536.5,65C 537.173,67.8587 538.007,70.692 539,73.5C 540.171,74.8932 541.671,75.7265 543.5,76C 552.167,76.6667 560.833,76.6667 569.5,76C 571.848,75.6541 573.681,74.4875 575,72.5C 576.262,68.0906 575.428,64.2572 572.5,61C 561.531,59.4307 550.531,58.0973 539.5,57C 532.507,55.0323 529.174,50.3657 529.5,43C 529.658,34.6929 533.658,29.5262 541.5,27.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 85.5,29.5 C 86.7868,30.8714 87.4535,32.7047 87.5,35C 87.7258,37.6709 87.0591,40.0042 85.5,42C 73.9962,48.9196 62.3295,55.5862 50.5,62C 70.3317,73.4148 89.9984,85.0814 109.5,97C 107.004,98.0804 104.67,99.4138 102.5,101C 100.833,101.667 99.1667,101.667 97.5,101C 75.1667,88.1667 52.8333,75.3333 30.5,62.5C 49.0268,51.7402 67.3601,40.7402 85.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959596",
    d: "M 225.5,42.5 C 224.833,56.1667 224.167,69.8333 223.5,83.5C 223.333,69.1628 223.5,54.8295 224,40.5C 224.717,41.0442 225.217,41.7109 225.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6a6a6b",
    d: "M 273.5,83.5 C 272.833,69.8333 272.167,56.1667 271.5,42.5C 271.783,41.7109 272.283,41.0442 273,40.5C 273.5,54.8295 273.667,69.1628 273.5,83.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogoBlack);
export default __webpack_public_path__ + "static/media/full_logo_black.a9ade720bb7f1dd35ca1469d60c37610.svg";
export { ForwardRef as ReactComponent };